import { useQuery } from "react-query";
import { getShots, getUneditedFallback } from "../lib/thumbnailData";

export const useGetPreferredShot = (wipId, hasEditedShots, reference) => {
    return useQuery({
        queryKey: ["preferredShot", wipId],
        enabled: !reference,
        queryFn: async () => {
            const shots = await getShots(wipId);

            return getUneditedFallback(shots, hasEditedShots);
        },
    });
};
